/** Hand a blob to the browser as a file download. */
export function triggerBlobDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    // Defer revocation: a synchronous revoke can race with the download start in Firefox and Safari.
    setTimeout(() => URL.revokeObjectURL(url), 0);
}
